interface Props {
  style?: React.CSSProperties;
  relHeight?: number;
  relSide?: number;
}

export const ReleasePointVis: React.FC<Props> = ({
  style,
  relHeight,
  relSide,
}) => {
  const strokeFill = "#3B82F6"; // blue-500
  const ballFill = "#3B82F6"; // blue-500

  const calcRelSideCoordinate = (RelSideFeet: number) => {
    return RelSideFeet * 12 * 8.3333333;
  };

  const calcRelHeightCoordinate = (RelHeightFeet: number) => {
    return (8 - RelHeightFeet) * 12 * 8.3333333;
  };

  return (
    <svg
      style={style || { width: "100%" }}
      viewBox="0 0 886 879"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Map the release point onto the svg grid */}
      {relSide && relHeight && (
        <circle
          cx={485.5 + calcRelSideCoordinate(relSide)}
          cy={46 + calcRelHeightCoordinate(relHeight)}
          r="20"
          fill={ballFill}
        />
      )}

      {/* Mapping for where the release grid starts and ends on the SVG.
          Centerline is at x= 485.5
          1 foot = 100px
          1 inch = 8.33333px

          (87, 46)        (485.5, 0)      (885, 46)
              x------------|------------x
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              |            |            |
              x------------|------------x
          (87, 846)                    (885, 846) */}

      <path
        d="M885.2 800.776C814.87 777.311 629.738 764 487.197 764C327.744 764 158.396 777.66 86.7995 800.518C86.5315 800.604 86.2671 800.689 86 800.776V846H886L885.2 800.776Z"
        fill={strokeFill}
        fillOpacity="0.21"
      />
      <rect
        x="86.5"
        y="46.5"
        width="799"
        height="799"
        rx="3.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="745.5"
        x2="885"
        y2="745.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="645.5"
        x2="885"
        y2="645.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="546.5"
        x2="885"
        y2="546.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="87"
        y1="446.5"
        x2="886"
        y2="446.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="347.5"
        x2="885"
        y2="347.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="248.5"
        x2="885"
        y2="248.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="86"
        y1="148.5"
        x2="885"
        y2="148.5"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="485.5"
        y1="46"
        x2="485.5"
        y2="846"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="385.5"
        y1="46"
        x2="385.5"
        y2="846"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="285.5"
        y1="47"
        x2="285.5"
        y2="847"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="185.5"
        y1="47"
        x2="185.5"
        y2="847"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="585.5"
        y1="47"
        x2="585.5"
        y2="847"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="685.5"
        y1="47"
        x2="685.5"
        y2="847"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <line
        x1="785.5"
        y1="46"
        x2="785.5"
        y2="846"
        stroke={strokeFill}
        strokeOpacity=".6"
      />
      <path
        d="M30.1114 139.616V138.248H17.0794V135.8H32.8474V139.796L22.9834 161H20.1034L30.1114 139.616ZM47.3981 145.412H44.1581V143.072H47.3981V139.076L50.5301 135.944H55.7141V138.248H51.6821L50.0621 139.832V143.072H55.7141V145.412H50.0621V161H47.3981V145.412ZM60.9333 157.688V145.412H57.6933V143.072H61.0053V137.24H63.5973V143.072H69.2133V145.412H63.5973V156.86L65.3973 158.66H69.2133V161H64.2453L60.9333 157.688Z"
        fill={strokeFill}
      />
      <path
        d="M17.0864 257.688V239.112L20.3984 235.8H30.4784L33.7904 239.112V241.92H31.0544V240.012L29.2544 238.248H21.6224L19.8224 240.012V248.508L22.7384 245.592H30.6224L33.9344 248.904V257.688L30.6224 261H20.3984L17.0864 257.688ZM29.3984 258.552L31.1984 256.788V249.804L29.3984 248.04H23.4584L19.8224 251.676V256.788L21.6224 258.552H29.3984ZM49.1911 245.412H45.9511V243.072H49.1911V239.076L52.3231 235.944H57.5071V238.248H53.4751L51.8551 239.832V243.072H57.5071V245.412H51.8551V261H49.1911V245.412ZM62.7263 257.688V245.412H59.4863V243.072H62.7983V237.24H65.3903V243.072H71.0063V245.412H65.3903V256.86L67.1903 258.66H71.0063V261H66.0383L62.7263 257.688Z"
        fill={strokeFill}
      />
      <path
        d="M17.0077 356.688V353.88H19.7437V355.788L21.5437 357.552H29.1037L30.9037 355.788V348.588L29.1037 346.824H17.3677V334.8H33.1357V337.212H20.0317V344.376H30.2917L33.6397 347.724V356.688L30.3277 360H20.3197L17.0077 356.688ZM48.9098 344.412H45.6698V342.072H48.9098V338.076L52.0418 334.944H57.2258V337.248H53.1938L51.5738 338.832V342.072H57.2258V344.412H51.5738V360H48.9098V344.412ZM62.445 356.688V344.412H59.205V342.072H62.517V336.24H65.109V342.072H70.725V344.412H65.109V355.86L66.909 357.66H70.725V360H65.757L62.445 356.688Z"
        fill={strokeFill}
      />
      <path
        d="M28.6238 452.852H16.2398V448.604L27.0038 432.8H31.3598V450.404H34.4198V452.852H31.3598V458H28.6238V452.852ZM28.6238 450.476V435.104H28.4078L18.9038 449.036V450.476H28.6238ZM48.4177 442.412H45.1777V440.072H48.4177V436.076L51.5497 432.944H56.7337V435.248H52.7017L51.0817 436.832V440.072H56.7337V442.412H51.0817V458H48.4177V442.412ZM61.9528 454.688V442.412H58.7128V440.072H62.0248V434.24H64.6168V440.072H70.2328V442.412H64.6168V453.86L66.4168 455.66H70.2328V458H65.2648L61.9528 454.688Z"
        fill={strokeFill}
      />
      <path
        d="M16.7004 555.688V552.88H19.4364V554.788L21.2364 556.552H28.8684L30.6684 554.788V549.28L28.9404 547.552H21.7404V545.104H28.9404L30.6684 543.376V538.012L28.8684 536.248H21.4524L19.6524 538.012V539.92H16.9164V537.112L20.2284 533.8H30.0924L33.4044 537.112V544.168L31.2084 546.328L33.4044 548.524V555.688L30.0924 559H20.0124L16.7004 555.688ZM48.8571 543.412H45.6171V541.072H48.8571V537.076L51.9891 533.944H57.1731V536.248H53.1411L51.5211 537.832V541.072H57.1731V543.412H51.5211V559H48.8571V543.412ZM62.3923 555.688V543.412H59.1523V541.072H62.4643V535.24H65.0563V541.072H70.6723V543.412H65.0563V554.86L66.8563 556.66H70.6723V559H65.7043L62.3923 555.688Z"
        fill={strokeFill}
      />
      <path
        d="M17.3717 653.176L30.5477 640.144V637.012L28.7477 635.248H21.7637L19.9637 637.012V638.92H17.2277V636.112L20.5397 632.8H29.9717L33.2837 636.112V640.936L20.1077 653.968V655.552H33.4277V658H17.3717V653.176ZM48.3298 642.412H45.0898V640.072H48.3298V636.076L51.4618 632.944H56.6458V635.248H52.6138L50.9938 636.832V640.072H56.6458V642.412H50.9938V658H48.3298V642.412ZM61.8649 654.688V642.412H58.6249V640.072H61.9369V634.24H64.5289V640.072H70.1449V642.412H64.5289V653.86L66.3289 655.66H70.1449V658H65.1769L61.8649 654.688Z"
        fill={strokeFill}
      />
      <path
        d="M157.7 871.688V868.88H160.436V870.788L162.236 872.552H169.868L171.668 870.788V865.28L169.94 863.552H162.74V861.104H169.94L171.668 859.376V854.012L169.868 852.248H162.452L160.652 854.012V855.92H157.916V853.112L161.228 849.8H171.092L174.404 853.112V860.168L172.208 862.328L174.404 864.524V871.688L171.092 875H161.012L157.7 871.688ZM189.857 859.412H186.617V857.072H189.857V853.076L192.989 849.944H198.173V852.248H194.141L192.521 853.832V857.072H198.173V859.412H192.521V875H189.857V859.412ZM203.392 871.688V859.412H200.152V857.072H203.464V851.24H206.056V857.072H211.672V859.412H206.056V870.86L207.856 872.66H211.672V875H206.704L203.392 871.688Z"
        fill={strokeFill}
      />
      <path
        d="M258.372 870.176L271.548 857.144V854.012L269.748 852.248H262.764L260.964 854.012V855.92H258.228V853.112L261.54 849.8H270.972L274.284 853.112V857.936L261.108 870.968V872.552H274.428V875H258.372V870.176ZM289.33 859.412H286.09V857.072H289.33V853.076L292.462 849.944H297.646V852.248H293.614L291.994 853.832V857.072H297.646V859.412H291.994V875H289.33V859.412ZM302.865 871.688V859.412H299.625V857.072H302.937V851.24H305.529V857.072H311.145V859.412H305.529V870.86L307.329 872.66H311.145V875H306.177L302.865 871.688Z"
        fill={strokeFill}
      />
      <path
        d="M366.965 852.608L361.313 855.524V853.004L367.181 849.8H369.701V875H366.965V852.608ZM385.884 859.412H382.644V857.072H385.884V853.076L389.016 849.944H394.2V852.248H390.168L388.548 853.832V857.072H394.2V859.412H388.548V875H385.884V859.412ZM399.42 871.688V859.412H396.18V857.072H399.492V851.24H402.084V857.072H407.7V859.412H402.084V870.86L403.884 872.66H407.7V875H402.732L399.42 871.688Z"
        fill={strokeFill}
      />
      <path
        d="M314.429 2.8H328.829L332.141 6.112V14.212L328.793 17.56H317.165V28H314.429V2.8ZM327.641 15.184L329.441 13.42V6.94L327.641 5.176H317.165V15.184L327.641 15.184ZM336.463 5.968V4.384L337.543 3.304H339.127L340.207 4.384V5.968L339.127 7.048H337.543L336.463 5.968ZM337.003 10.072H339.667V28H337.003V10.072ZM347.052 24.688V12.412H343.812V10.072H347.124V4.24H349.716V10.072H355.332V12.412H349.716V23.86L351.516 25.66H355.332V28H350.364L347.052 24.688ZM358.572 24.688V13.384L361.884 10.072H370.524L373.836 13.384V15.58H371.172V14.212L369.372 12.448H363.036L361.236 14.212V23.86L363.036 25.624H369.372L371.172 23.86V22.492H373.836V24.688L370.524 28H361.884L358.572 24.688ZM378.163 2.296H380.827V13.816L384.571 10.072H390.151L393.463 13.384V28H390.799V14.212L388.999 12.448H385.291L380.827 16.912V28H378.163V2.296ZM398.334 24.688V13.384L401.646 10.072H410.682L414.03 13.384V19.828L400.998 19.828V23.86L402.798 25.624L409.53 25.624L411.33 23.86V22.492H413.994V24.688L410.682 28L401.646 28L398.334 24.688ZM411.366 17.524V14.212L409.566 12.448H402.798L400.998 14.212V17.524L411.366 17.524ZM418.874 10.072H421.466V13.276L424.67 10.072H429.314V12.448H425.354L421.538 16.264V28H418.874V10.072ZM433.373 6.472H432.941L431.897 5.428V3.844L432.941 2.8H434.525L435.569 3.844V6.472L433.769 10.936H432.293L433.373 6.472ZM438.329 25.048V22.816H440.993V24.292L442.433 25.696H449.057L450.497 24.292V21.52L449.057 20.08H441.317L438.473 17.236V13.024L441.425 10.072H449.849L452.801 13.024V15.256H450.137V13.78L448.697 12.376H442.577L441.137 13.78V16.408L442.577 17.848H450.209L453.161 20.8V25.048L450.209 28H441.281L438.329 25.048ZM466.62 2.8L481.02 2.8L484.332 6.112V14.212L480.984 17.56H469.356V28H466.62V2.8ZM479.832 15.184L481.632 13.42V6.94L479.832 5.176H469.356V15.184H479.832ZM487.561 24.688V13.384L490.873 10.072L499.909 10.072L503.257 13.384V19.828H490.225V23.86L492.025 25.624H498.757L500.557 23.86V22.492H503.221V24.688L499.909 28H490.873L487.561 24.688ZM500.593 17.524V14.212L498.793 12.448L492.025 12.448L490.225 14.212V17.524H500.593ZM508.1 10.072H510.692V13.276L513.896 10.072H518.54V12.448H514.58L510.764 16.264V28H508.1V10.072ZM520.525 25.048V22.816H523.189V24.292L524.629 25.696H531.253L532.693 24.292V21.52L531.253 20.08H523.513L520.669 17.236V13.024L523.621 10.072H532.045L534.997 13.024V15.256H532.333V13.78L530.893 12.376H524.773L523.333 13.78V16.408L524.773 17.848H532.405L535.357 20.8V25.048L532.405 28H523.477L520.525 25.048ZM539.846 10.072H542.438V13.276L545.642 10.072H552.374L555.686 13.384V24.688L552.374 28H545.462L542.51 25.408V35.632H539.846V10.072ZM551.222 25.624L553.022 23.86V14.212L551.222 12.448H546.362L542.51 16.3V22.492L545.966 25.624H551.222ZM560.369 24.688V13.384L563.681 10.072H572.717L576.065 13.384V19.828H563.033V23.86L564.833 25.624H571.565L573.365 23.86V22.492H576.029V24.688L572.717 28H563.681L560.369 24.688ZM573.401 17.524V14.212L571.601 12.448H564.833L563.033 14.212V17.524H573.401ZM580.549 24.688V13.384L583.861 10.072H592.501L595.813 13.384V15.58H593.149V14.212L591.349 12.448H585.013L583.213 14.212V23.86L585.013 25.624H591.349L593.149 23.86V22.492H595.813V24.688L592.501 28H583.861L580.549 24.688ZM601.759 24.688V12.412H598.519V10.072H601.831V4.24H604.423V10.072H610.039V12.412H604.423V23.86L606.223 25.66H610.039V28H605.071L601.759 24.688ZM613.987 5.968V4.384L615.067 3.304H616.651L617.731 4.384V5.968L616.651 7.048H615.067L613.987 5.968ZM614.527 10.072H617.191V28H614.527V10.072ZM620.796 10.072H623.532L628.86 25.336H629.004L634.332 10.072H637.068L630.48 28H627.384L620.796 10.072ZM639.611 24.688V13.384L642.923 10.072H651.959L655.307 13.384V19.828H642.275V23.86L644.075 25.624H650.807L652.607 23.86V22.492H655.271V24.688L651.959 28H642.923L639.611 24.688ZM652.643 17.524V14.212L650.843 12.448H644.075L642.275 14.212V17.524H652.643Z"
        fill={strokeFill}
      />
      <path
        d="M566.965 852.608L561.313 855.524V853.004L567.181 849.8H569.701V875H566.965V852.608ZM585.884 859.412H582.644V857.072H585.884V853.076L589.016 849.944H594.2V852.248H590.168L588.548 853.832V857.072H594.2V859.412H588.548V875H585.884V859.412ZM599.42 871.688V859.412H596.18V857.072H599.492V851.24H602.084V857.072H607.7V859.412H602.084V870.86L603.884 872.66H607.7V875H602.732L599.42 871.688Z"
        fill={strokeFill}
      />
      <path
        d="M658.372 870.176L671.548 857.144V854.012L669.748 852.248H662.764L660.964 854.012V855.92H658.228V853.112L661.54 849.8H670.972L674.284 853.112V857.936L661.108 870.968V872.552H674.428V875H658.372V870.176ZM689.33 859.412H686.09V857.072H689.33V853.076L692.462 849.944H697.646V852.248H693.614L691.994 853.832V857.072H697.646V859.412H691.994V875H689.33V859.412ZM702.865 871.688V859.412H699.625V857.072H702.937V851.24H705.529V857.072H711.145V859.412H705.529V870.86L707.329 872.66H711.145V875H706.177L702.865 871.688Z"
        fill={strokeFill}
      />
      <path
        d="M757.7 871.688V868.88H760.436V870.788L762.236 872.552H769.868L771.668 870.788V865.28L769.94 863.552H762.74V861.104H769.94L771.668 859.376V854.012L769.868 852.248H762.452L760.652 854.012V855.92H757.916V853.112L761.228 849.8H771.092L774.404 853.112V860.168L772.208 862.328L774.404 864.524V871.688L771.092 875H761.012L757.7 871.688ZM789.857 859.412H786.617V857.072H789.857V853.076L792.989 849.944H798.173V852.248H794.141L792.521 853.832V857.072H798.173V859.412H792.521V875H789.857V859.412ZM803.392 871.688V859.412H800.152V857.072H803.464V851.24H806.056V857.072H811.672V859.412H806.056V870.86L807.856 872.66H811.672V875H806.704L803.392 871.688Z"
        fill={strokeFill}
      />
      <rect x="385" y="761" width="200" height="16" fill={strokeFill} />
    </svg>
  );
};
